import { render, staticRenderFns } from "./PostLinks.vue?vue&type=template&id=209d7167&"
import script from "./PostLinks.vue?vue&type=script&lang=js&"
export * from "./PostLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports